import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按主题浏览文章，快速找到你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 flex flex-col items-center text-center cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                {category.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {category.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}